import React from 'react'
import moment from "moment";
import SelectedCheckbox from "./SelectedCheckbox";

function ListCustomerTableItem(props) {
    const {item, arrSelected, onSelected} = props

    return (
        <tr className="RowItem">
            <td className="selectItem">
                <SelectedCheckbox
                    id={item.contactListId}
                    arrSelected={arrSelected}
                    onSelected={onSelected}
                />
            </td>
            <td className="itemCol">
                {item.contactListName || ''}
            </td>
            <td className="itemCol">{item.numberOfContact}</td>
            <td className="itemCol">{item.createAt && moment(item.createAt).format('DD/MM/YYYY')}</td>
            <td className="itemCol">{item.createBy}</td>
        </tr>
    )
}

export default ListCustomerTableItem
